import React from 'react';
import './PersonProfile.css';
import { PageTitle } from '../../../components';
import { useTranslation } from 'react-i18next';
import { personData, titles } from '../../../constants';

const PersonProfile = () => {
    const { t } = useTranslation();

    const paragraphs = personData.descriptionKeys || personData.description || [];
    const roleText = personData.roleKey ? t(personData.roleKey) : personData.role;

    return (
        <div className="person-profile-wrapper">
            <PageTitle title={t(titles.poznajnas)} page={t(titles.poznajnas)} />
            
            <section className='person-profile-section'>
                <div className='person-profile-container'>
                    
                    {/* Lewa kolumna - Zdjęcie */}
                    <div className='person-profile-image-wrapper'>
                        <img 
                            src={personData.image} 
                            alt={personData.name} 
                            className="person-profile-img"
                        />
                    </div>

                    {/* Prawa kolumna - Treść (Opis) */}
                    <div className='person-profile-content'>
                        <h3 className='person-profile-name'>{personData.name}</h3>
                        <h4 className="person-profile-role">{roleText}</h4>
                        
                        <div className="person-profile-text-body">
                            {/* Wykorzystujemy naszą bezpieczną zmienną paragraphs */}
                            {paragraphs.map((paragraphItem, index) => (
                                <p key={index} className="person-profile-paragraph">
                                    {t(paragraphItem)}
                                </p>
                            ))}
                        </div>
                    </div>
                    
                </div>
            </section>
        </div>
    );
};

export default PersonProfile;